import { Component } from "@angular/core";
import {environment} from "../../../environments/environment";

@Component({
	selector: "app-footer",
	templateUrl: "./footer.component.html",
	styleUrls: ["./footer.component.scss"]
})
export class FooterComponent {
	currentYear: string = "";
	currentVersion: string;

	constructor() {}

	ngOnInit() {
		this.currentYear = new Date().getFullYear().toString();
		this.currentVersion = environment.appVersion;
		console.log("Current Version:" + this.currentVersion);
	}
}
